import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SCHEDULE_ASSIGNMENTS } from "../../../feature-flag-schedule-assignments"
import { SkillMapSkillRoutingTop, SkillMapTradeRowExtra, SkillMapViewModes } from "../skill-map-view-slot-definitions"
import { SkillMapViewMode } from "../skill-map-view-mode"
import { ScheduleAssignmentsPanel } from "./schedule-assignments-panel"
import { ScheduleAssignmentsBanner } from "./schedule-assignments-banner"
import { TradeAssignmentSummary } from "./trade-assignment-summary"

// FIQ-2457: schedule assignments add a view to the skill map, a summary banner above skill
// routing and a per-trade summary, all behind the flag
SkillMapViewModes.plug(
    <SkillMapViewMode value="assignments" label="Schedule assignments" priority={20} if={isOn}>
        <ScheduleAssignmentsPanel $lazy />
    </SkillMapViewMode>
)
SkillMapSkillRoutingTop.plug(<ScheduleAssignmentsBanner if={isOn} />)
SkillMapTradeRowExtra.plug(<TradeAssignmentSummary if={isOn} />)

function isOn() {
    return isEnabled(FEATURE_FLAG_SCHEDULE_ASSIGNMENTS)
}
